const patientTypes = {
  GET_PATIENTS: 'GET_PARTNERS',
  GET_SINGLE_PATIENT: 'GET_SINGLE_PATIENT',
  DELETE_PATIENT: 'DELETE_PATIENT'
};

export default patientTypes;
